import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { MessageService } from "primeng/api";
import { Observable } from "rxjs";
import { AuthData } from "../core/data";

@Injectable({
    providedIn: "root",
})
export class AuthGuard  {
    constructor(
        private authServiceApi: AuthData,
        private router: Router,
        private messageService: MessageService
    ) {}
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
      
        if (this.authServiceApi.isLoggedIn()) {
            var userRole = this.authServiceApi.getRole();
            if (route.data.roles && route.data.roles.indexOf(userRole) === -1) {
                localStorage.clear();
                sessionStorage.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Unauthorized",
                    detail: "You don't have permission to access requested resource!",
                }); 
                this.router.navigate(["/login"]);
                return false;
            }
            return true;
        }
        else {
            localStorage.clear();
            sessionStorage.clear();
            this.router.navigate(["/login"]);
            return false;
        }
    }
}
